import React from 'react';
import MainLayout from '@/layouts/MainLayout/MainLayout.tsx';
import styles from './Error50x.module.scss';
import FlexBlock from '@/components/ui/FlexBlock/FlexBlock.tsx';

const Error50x: React.FC = () => {
	return (
		<MainLayout>
			<FlexBlock
				flexDirection="column"
				justifyContent="center"
				alignItems="center"
				className={styles.serverErrorWrapper}
			>
				<h1>Oops! Something went wrong.</h1>
				<p>
					We're having a bit of trouble right now. Please try again in a few minutes. If the issue continues,
					feel free to contact support.
				</p>
			</FlexBlock>
		</MainLayout>
	);
};

export default Error50x;
